/* eslint-disable max-lines */
// Reference:https://app.clickup.com/9003040700/v/dc/8c9yzxw-27836/8c9yzxw-74116

import moment from 'moment';

import { FSOperation, IAchievements, IAuthUser } from './DatabaseInterface';

// TODO: Check and update the spec
export const setUserReferrerID = (
  userID: string,
  referrerId: string,
): FSOperation => {
  return {
    data: { referrer: referrerId },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

// TODO: Check and update the spec
export const updateAchievements = (
  userID: string,
  achievementLists: IAchievements[],
): FSOperation => {
  return {
    data: { profile: { achievements: achievementLists } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateClickID = (uid: string, clickID: string): FSOperation => {
  return {
    data: {
      'profile.userInfo.clickID': clickID,
    },
    docPath: `users/${uid}`,
    operation: 'update',
  };
};

// TODO: Check and update the spec
export const updateCoins = (
  userID: string,
  totalCoins: number,
  targetLanguage: string,
): FSOperation => {
  return {
    data: { coins: totalCoins },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateExtraContentEligibility = (
  userID: string,
  targetLanguage: string,
  isExtraContentAvailable: boolean,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { isExtraContentAvailable: isExtraContentAvailable },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

export const updateIsEffectEnabled = (
  userID: string,
  isEffectEnabled: boolean,
): FSOperation => {
  return {
    data: {
      'settings.isEffectEnabled': isEffectEnabled,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateIsReminderOn = (
  userID: string,
  flag: boolean,
): FSOperation => {
  return {
    data: {
      'settings.isReminderOn': flag,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateIsSoundAutoPlayOn = (
  userID: string,
  isSoundAutoPlayOn: boolean,
): FSOperation => {
  return {
    data: {
      'settings.isSoundAutoPlayOn': isSoundAutoPlayOn,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateIsTranscriptEnabled = (
  userID: string,
  isTranscriptEnabled: boolean,
): FSOperation => {
  return {
    data: {
      'settings.isTranscriptEnabled': isTranscriptEnabled,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateIsWeeklyProgressOn = (
  userID: string,
  isWeeklyProgressOn: boolean,
): FSOperation => {
  return {
    data: {
      'settings.isWeeklyProgressOn': isWeeklyProgressOn,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateName = (userID: string, name: string): FSOperation => {
  return {
    data: {
      'profile.name': name,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updatePhotoURL = (
  userID: string,
  photoURL: string,
): FSOperation => {
  return {
    data: {
      'profile.photoURL': photoURL,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateReminders = (
  userID: string,
  payload: {
    weekDays: { day: string; isSelected: boolean }[];
    reminderTime: { hour: number; minute: number };
    reminderGoal: number;
  },
): FSOperation => {
  return {
    data: {
      'reminders.reminderGoal': payload.reminderGoal,
      'reminders.reminderTime': payload.reminderTime,
      'reminders.weekDays': payload.weekDays,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateTargetLanguage = (
  userID: string,
  targetLanguage: string,
): FSOperation => {
  return {
    data: {
      'profile.targetLanguage': targetLanguage,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateNativeLanguageDB = (
  userID: string,
  nativeLanguage: string,
): FSOperation => {
  return {
    data: {
      'profile.nativeLanguage': nativeLanguage,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

// TODO: Check and update the spec
export const updateTrial = (
  userID: string,
  trialEndDate: Date,
  trialPeriod: number,
  trialStartDate: Date,
): FSOperation => {
  return {
    data: {
      'profile.trial': {
        endDate: trialEndDate,
        period: trialPeriod,
        startDate: trialStartDate,
      },
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

export const updateUUID = (userID: string, uuid: string): FSOperation => {
  return {
    data: { profile: { uuid } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateIsUserTrialEligible = (
  userID: string,
  isUserTrialEligible: boolean,
): FSOperation => {
  return {
    data: { profile: { isUserTrialEligible } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateUsedLanguagesIds = (
  userID: string,
  uniqueUsedLanguagesIds: string[],
): FSOperation => {
  return {
    data: {
      'profile.usedLanguagesIds': uniqueUsedLanguagesIds,
    },
    docPath: `users/${userID}`,
    operation: 'update',
  };
};

// TODO: Check and update the spec
export const updateUserBananaPoints = (
  addedPoints: number,
  userID: string,
  currentPoints: number,
  targetLanguage: string,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { bananas: currentPoints + addedPoints },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

export const updateUserChatbot = (
  userID: string,
  targetLanguage: string,
  chatbotId: number,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { progressChatbot: { [chatbotId]: { isFinished: true } } },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

export const updateUserAITutorProgress = (
  userID: string,
  targetLanguage: string,
  lessonId: string,
  progress: {
    completed: boolean;
    completedAt: number;
    crown?: number;
  },
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: {
      progressAITutor: {
        [lessonId]: {
          completed: progress.completed,
          completedAt: progress.completedAt,
          ...(progress.crown !== undefined ? { crown: progress.crown } : {}),
        },
      },
    },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateUserCoins = (
  addedCoins: number,
  userID: string,
  currentCoins: number,
  targetLanguage: string,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { coins: currentCoins + addedCoins },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateUserCrowns = (
  userID: string,
  targetLanguage: string,
  unit: string,
  lesson: number,
  wrongAnswers: number,
  isExam: boolean,
  isWritingGame: boolean,
  isAppInChina: boolean,
  isUniqueCourse: boolean,
  nativeLanguage?: string,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: {
      [!isUniqueCourse
        ? `progress.${unit}.${lesson}`
        : `uniqueProgress.${nativeLanguage}.${unit}.${lesson}`]: {
        crowns: 1,
        finished: true,
        isExam,
        isWritingGame,
        wrongAnswers,
      },
    },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateUserCurrentStreak = (
  userID: string,
  daysOnStreak: number,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { profile: { currentStreak: daysOnStreak } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateUserDefaultProperties = (
  user: IAuthUser,
  targetLanguage: string,
  referrer: string,
): FSOperation => {
  // Initializes a new user profile with default values
  // Uses set_with_merge to avoid overwriting existing data
  // Default values: 0 bananas/coins, empty streaks, single language in usedLanguagesIds
  return {
    data: {
      profile: {
        bananas: 0,
        coins: 0,
        streakSaver: {
          earnedStreakSaver: 1, // Default value for new and existing users
          appliedDates: [],
          earnedDates: [],
          realConsecutiveDays: 7, // Added to track real consecutive days for streak saver
        },
        currentStreak: 0,
        email: user.email,
        isAnonymous: false,
        dateLastPlayed: moment().clone().subtract(1, 'day').local().unix(), // Set to yesterday for new users to earn a streak
        longestStreak: 0,
        name: user.displayName || '',
        photoURL: user.photoURL || '',
        referrer,
        streakRecords: [],
        targetLanguage,
        uid: user.uid,
        usedLanguagesIds: [targetLanguage],
      },
    },
    docPath: `users/${user.uid}`,
    operation: 'set_with_merge',
  };
};

export const updateUserInfo = (
  userID: string,
  userInfo: Record<string, unknown>,
): FSOperation => {
  return {
    data: { profile: { userInfo: userInfo } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateUserLastDayPlayed = (
  userID: string,
  dateLastPlayed: number,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { profile: { dateLastPlayed } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateUserLongestStreak = (
  userID: string,
  streak: number,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { profile: { longestStreak: streak } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

// TODO: Check and update the spec
export const updateUserStreakRecords = (
  userID: string,
  updatedStreakRecords: Array<string>,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { profile: { streakRecords: updatedStreakRecords } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateVoiceSpeed = (
  userID: string,
  voiceSpeed: number,
): FSOperation => {
  return {
    data: { settings: { voiceSpeed: voiceSpeed } },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateWeekNumber = (
  userID: string,
  weekNumber: number,
  targetLanguage: string,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: { goal: { weekNumber } },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

export const updateWeeklyGraph = (
  userID: string,
  dayNumber: number,
  addedPoints: number,
  currentDayPoints: number,
  targetLanguage: string,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: {
      goal: {
        weeklyGraphData: { [dayNumber]: currentDayPoints + addedPoints },
      },
    },
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

// Updating user data on Ling Web on sign up
export const setOrUpdateUserDataOnSignUp = (
  userID: string,
  email: string,
  name: string,
  photoURL: string,
  targetLanguage: string,
  nativeLanguage: string,
  uuid = '',
): FSOperation => {
  return {
    data: {
      profile: {
        email,
        name,
        nativeLanguage,
        photoURL,
        targetLanguage,
        uid: userID,
        uuid,
        streakSaver: {
          earnedStreakSaver: 1, // Default value for new and existing users
          appliedDates: [],
          earnedDates: [],
          realConsecutiveDays: 7,
        },
        currentStreak: 0,
        longestStreak: 0,
      },
      settings: {
        isEffectEnabled: true,
        isReminderOn: false,
        isSoundAutoPlayOn: true,
        isTranscriptEnabled: true,
        isWeeklyProgressOn: true,
        voiceSpeed: 1,
      },
    },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const getUserProfile = (userID: string): FSOperation => {
  return {
    docPath: `users/${userID}`,
    operation: 'read',
    propertiesPath: ['profile'],
  };
};

export const getUserLanguageProgress = (
  userID: string,
  targetLanguage: string,
): FSOperation => {
  return {
    docPath: `users/${userID}/languageProgress/${targetLanguage}`,
    operation: 'read',
    propertiesPath: [
      'bananas',
      'goal',
      'progress',
      'uniqueProgress',
      'progressChatbot',
      'progressAITutor',
    ],
  };
};

export const getUserData = (userID: string): FSOperation => {
  return {
    docPath: `users/${userID}`,
    operation: 'read',
    propertiesPath: ['profile', 'settings', 'reminders'],
  };
};

export const updateUserLessonCrowns = (
  userID: string,
  targetLanguage: string,
  unitId: number,
  lessonId: number,
  crowns: number,
  isAppInChina: boolean,
  isUniqueCourse: boolean,
  nativeLanguage?: string,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  if (isUniqueCourse) {
    if (nativeLanguage) {
      return {
        data: {
          uniqueProgress: {
            [nativeLanguage]: { [unitId]: { [lessonId]: crowns } },
          },
        },
        docPath: `users/${userID}/languageProgress/${targetLanguage}`,
        operation: 'set_with_merge',
      };
    } else {
      return {
        docPath: '',
        operation: 'no_op',
      };
    }
  } else {
    return {
      data: { progress: { [unitId]: { [lessonId]: crowns } } },
      docPath: `users/${userID}/languageProgress/${targetLanguage}`,
      operation: 'set_with_merge',
    };
  }
};

export const getFavoriteWords = (
  userID: string,
  nativeLanguage: string,
  targetLanguage: string,
): FSOperation => {
  return {
    docPath: `users/${userID}/favoriteWords/${nativeLanguage}_${targetLanguage}`,
    operation: 'read',
    propertiesPath: ['favoriteWords'],
  };
};

export const addToFavoriteWords = (
  isAppInChina: boolean,
  userID: string,
  nativeLanguage: string,
  targetLanguage: string,
  wordId: string,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }
  return {
    data: {
      favoriteWords: {
        [wordId]: true,
      },
    },
    docPath: `users/${userID}/favoriteWords/${nativeLanguage}_${targetLanguage}`,
    operation: 'set_with_merge',
  };
};

export const removeFromFavoriteWords = (
  isAppInChina: boolean,
  userID: string,
  nativeLanguage: string,
  targetLanguage: string,
  wordId: string,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }
  return {
    dataPath: `favoriteWords.${wordId}`,
    docPath: `users/${userID}/favoriteWords/${nativeLanguage}_${targetLanguage}`,
    operation: 'delete_field',
  };
};

export const updateUserEarnedStreakSaver = (
  userID: string,
  streakSaver: number,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: {
      profile: {
        streakSaver: {
          earnedStreakSaver: streakSaver,
        },
      },
    },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateStreakSaverAppliedDates = (
  userID: string,
  appliedDates: string[],
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }
  return {
    data: {
      profile: {
        streakSaver: {
          appliedDates: appliedDates,
        },
      },
    },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateUserRealConsecutiveDays = (
  userID: string,
  realConsecutiveDays: number,
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: {
      profile: {
        streakSaver: {
          realConsecutiveDays: realConsecutiveDays,
        },
      },
    },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateUserStreakSaver = (
  userID: string,
  updatedStreakSaver: {
    earnedStreakSaver: number;
    appliedDates: Array<string>;
    earnedDates: Array<string>;
    realConsecutiveDays: number;
  },
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }

  return {
    data: {
      profile: {
        streakSaver: updatedStreakSaver,
      },
    },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};

export const updateStreakSaverEarnedDates = (
  userID: string,
  earnedDates: string[],
  isAppInChina: boolean,
): FSOperation => {
  if (isAppInChina) {
    return {
      docPath: '',
      operation: 'no_op',
    };
  }
  return {
    data: {
      profile: {
        streakSaver: {
          earnedDates: earnedDates,
        },
      },
    },
    docPath: `users/${userID}`,
    operation: 'set_with_merge',
  };
};
